module.exports = __webpack_public_path__ + "static/img/PSD63-A.5c23658.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productConter/params/mini/PSD63-A.png
// module id = paS8
// module chunks = 1